// export type MetricLengthString = 'kilometer' | 'hectometer' | 'decameter' | 'meter' | 'decimeter' | 'centimeter' | 'millimeter' | 'micrometer' | 'nanometer'
// export type MetricLengthUnit = 'km' | 'hm' | 'dam' | 'm' | 'dm' | 'cm' | 'mm' | 'μm' | 'nm'

// export type MetricWeightString = 'kilogram' | 'hectogram' | 'dekagram' | 'gram' | 'decigram' | 'centigram' | 'milligram' | 'microgram' | 'nanogram'
// export type MetricWeightUnit = 'kg' | 'hg' | 'dag' | 'g' | 'dg' | 'cg' | 'mg' | 'μg' | 'ng'

export enum MetricLength {
  Kilometer = 'kilometer',
  Hectometer = 'hectometer',
  Decameter = 'decameter',
  Meter = 'meter',
  Decimeter = 'decimeter',
  Centimeter = 'centimeter',
  Millimeter = 'millimeter',
  Micrometer = 'micrometer',
  Nanometer = 'nanometer'
}

export enum MetricLengthUnit {
  Kilometer = 'km',
  Hectometer = 'hm',
  Decameter = 'dam',
  Meter = 'm',
  Decimeter = 'dm',
  Centimeter = 'cm',
  Millimeter = 'mm',
  Micrometer = 'μm',
  Nanometer = 'nm'
}

export const LengthOrder = [
  MetricLengthUnit.Kilometer,
  MetricLengthUnit.Hectometer,
  MetricLengthUnit.Decameter,
  MetricLengthUnit.Meter,
  MetricLengthUnit.Decimeter,
  MetricLengthUnit.Centimeter,
  MetricLengthUnit.Millimeter,
  MetricLengthUnit.Micrometer,
  MetricLengthUnit.Nanometer
]

export enum MetricWeightString {
  Kilogram = 'kilogram',
  Hectogram = 'hectogram',
  Dekagram = 'dekagram',
  Gram = 'gram',
  Decigram = 'decigram',
  Centigram = 'centigram',
  Milligram = 'milligram',
  Microgram = 'microgram',
  Nanogram = 'nanogram'
}

export enum MetricWeightUnit {
  Kilogram = 'kg',
  Hectogram = 'hg',
  Dekagram = 'dag',
  Gram = 'g',
  Decigram = 'dg',
  Centigram = 'cg',
  Milligram = 'mg',
  Microgram = 'μg',
  Nanogram = 'ng'
}
export const WeightOrder = [
  MetricWeightUnit.Kilogram,
  MetricWeightUnit.Hectogram,
  MetricWeightUnit.Dekagram,
  MetricWeightUnit.Gram,
  MetricWeightUnit.Decigram,
  MetricWeightUnit.Centigram,
  MetricWeightUnit.Milligram,
  MetricWeightUnit.Microgram,
  MetricWeightUnit.Nanogram
]


export interface Dimensions {
  x: number
  y: number
  z?: number
  unit?: MetricLengthUnit
  capacity?: number

  // TEMP FIXME:
  weight_unit?: MetricWeightUnit
}
